import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Box, Typography } from '@mui/material';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAppSelector } from 'app/hooks';
import Header from 'components/organisms/Header/HomeHeader';
import MobileHeader from 'components/organisms/Header/MobileHomeHeader';
import { selectAuth } from 'features/auth/authSlice';

const Setting = () => {
  const authState = useAppSelector(selectAuth);
  const matches = useMediaQuery('(max-width:600px)');

  return (
    <>
      {matches ? <MobileHeader /> : <Header />}
      <Box
        mt={matches ? 3 : 20}
        sx={{
          display: 'flex',
          flexWrap: matches ? 'wrap' : 'nowrap',
          justifyContent: 'center',
          width: '100%',
          gap: '10px',
        }}
      >
        <List
          sx={{
            width: matches ? '80%' : '30%',
            maxWidth: '100%',
            bgcolor: 'rgba(255,255,255,0.09803921568627451)',
            color: 'white',
          }}
        >
          <ListItemButton>
            <ListItemIcon>
              <AccountBalanceWalletOutlinedIcon sx={{ color: 'white' }} />
            </ListItemIcon>
            <ListItemText primary="Custodial wallet" />
          </ListItemButton>
        </List>

        <Box
          sx={{
            backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
            // width: '50%',
            width: matches ? '75%' : '50%',
            color: 'white',
          }}
          p={2}
        >
          <Box mt={1}>
            <Typography variant="h6">Your Wallets</Typography>
          </Box>

          <Typography sx={{ color: 'gray' }} variant="body1">
            Your primary wallet will be the Polygon address that automatically
            recieves your drops on showtime
          </Typography>

          <Typography
            variant="body2"
            color={'inherit'}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              margin: '7px 0 7px 0',
            }}
          >
            <EmailOutlinedIcon fontSize={'small'} />
            {authState.email && authState.email}
          </Typography>

          <Typography
            variant="body2"
            color={'inherit'}
            sx={{
              wordBreak: 'break-all',
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
            }}
          >
            <AccountBalanceWalletOutlinedIcon fontSize={'small'} />
            {authState.tatumWalletAddress && authState.tatumWalletAddress}
          </Typography>
        </Box>
      </Box>
    </>
  );
};
export default Setting;
